import './DegradedQualityIndicator.scss';

export { default } from './DegradedQualityIndicator';
